import API from 'types/api';
import APP from 'types/app';
import _ from 'lodash';

const initialState = {
  isLoading: false,
  isError: false, // ошибка в запросе самом
  errors: null, // апи вернул ошибки (например неверный пароль)
};
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case API.POST_AUTH_FETCH:
      return { ...state, isLoading: true };
    case API.POST_AUTH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: null,
      };
    case API.POST_AUTH_ERROR:
      if (payload.code === 200 || payload.code === 403) {
        // ошибка валидации
        return {
          ...state,
          isLoading: false,
          isError: false,
          errors: payload.response.errors,
        };
      }
      return {
        ...state,
        isLoading: false,
        isError: true,
        errors: null,
      };
    case APP.RESET_SERVICE_API_DATA:
      if (payload === 'login') {
        return {
          ...initialState,
        };
      }
      return state;
    case APP.REMOVE_API_RESPONSE_ERROR:
      if (payload.type === 'login' && _.isArray(state.errors) && state.errors.length > 0) {
        return {
          ...state,
          errors: state.errors.reduce((prev, item) => {
            if (item.field !== payload.field) {
              prev.push(item);
            }
            return prev;
          }, []),
        };
      }
      return state;
    default:
      return state;
  }
};
